import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { localize } from 'helpers/translator'
import Modalizer from 'components/modalizer/modalizer'
import { MainButton } from 'components/button'
import animations from 'animations/paths'
import ContentInformation from './components/content/view'


import styles from './nickel_tour_overlay.scss'

const NICKET_TOUR_ANIMATION_LESSON_INTERACTIVE = animations.NICKET_TOUR_LESSON_INTERACTIVE
const NICKET_TOUR_ANIMATION_PRE_MADE_LESSONS = animations.NICKET_TOUR_PRE_MADE_LESSONS
const NICKET_TOUR_ANIMATION_REPORTS = animations.NICKET_TOUR_REPORTS

class NickelTourOverlay extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			step: 0,
			startTime: Date.now(),
		}

		this.content = [
			{
				title: localize('nickelTour_lessonInteractive_title'),
				description: localize('nickelTour_lessonInteractive_description'),
				animationPath: NICKET_TOUR_ANIMATION_LESSON_INTERACTIVE,
			},
			{
				title: localize('nickelTour_preMadeLessons_title'),
				description: localize('nickelTour_preMadeLessons_description'),
				animationPath: NICKET_TOUR_ANIMATION_PRE_MADE_LESSONS,
			},
			{
				title: localize('nickelTour_reports_title'),
				description: localize('nickelTour_reports_description'),
				animationPath: NICKET_TOUR_ANIMATION_REPORTS,
			},
		]
	}

	isLastStep = () => this.state.step === this.content.length - 1

	goToNextStep = () => {
		this.setState({
			step: this.state.step + 1,
		})
	}

	onSelect = () => {
		if (this.isLastStep()) {
			this.props.complete(Date.now() - this.state.startTime)
		} else {
			this.goToNextStep()
		}
	}

	onClose = () => {
		this.props.close(this.state.step + 1)
	}

	render() {

		return (
			<Modalizer
				width='500px'
				boxed={false}
				canCloseOnVeil={false}
				closeButton={true}
				closeAction={this.onClose}
			>
				<div styleName='wrapper'>
					<div styleName='content'>
						<ContentInformation
							title={this.content[this.state.step].title}
							description={this.content[this.state.step].description}
							path={this.content[this.state.step].animationPath}
						/>
					</div>
					<div styleName='footer'>
						<div styleName='footer-dots'>
							{this.content.map((item, index) => (
								<span
									key={index}
									styleName={classNames({
										'footer-dots-item': true,
										'footer-dots-item--highlighted': this.state.step === index,
									})}
								></span>
							))}
						</div>
						<div styleName='footer-button'>
							<MainButton onClick={this.onSelect}>
								{this.isLastStep() ? localize('nickelTour_button_complete_text') : localize('nickelTour_button_common_text')}
							</MainButton>
						</div>
					</div>
				</div>
			</Modalizer>
		)
	}
}

NickelTourOverlay.propTypes = {
	close: PropTypes.func.isRequired,
	complete: PropTypes.func.isRequired,
}

export default CSSModules(
	NickelTourOverlay, styles, {allowMultiple: true}
)

export { NickelTourOverlay }
